import React, {FC, useEffect, useState} from 'react'
import { PermissionTable } from './components/PermissionTable';
import axios from 'axios'
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_PERMISSIONS_URL = `${API_URL_API}/permission`


const PermissionListPage: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);


  useEffect(() => {
    getAllPermission()
  },[])


  const getAllPermission = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const {data: result} = await axios.get(GET_ALL_PERMISSIONS_URL,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setPermissions(result.data);
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
               <PermissionTable permissions={permissions} getAllPerm={getAllPermission} className='mb-5 mb-xl-8' /> 
          )
        }

          
        </>
  )
}

export {PermissionListPage}
